module.exports = __webpack_public_path__ + "static/media/railways_c.105d883d.tif";